export default __webpack_public_path__ + "static/colin-profile-c076b9593ed152fc29486791292dfc8e.png";